import React from "react"

import { Redirect, withRouter } from "react-router-dom"
import { Form, Icon, Input, Button, Tooltip, message } from 'antd'
import { Auth } from "aws-amplify"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

import LoginBase from './LoginBase'

class MFALoginForm extends React.Component{

    async onSubmit(e) {

        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                this.context[1]({type:'call'})
                Auth.confirmSignIn(
                    this.props.login.user,
                    values.mfa_code,
                    'SOFTWARE_TOKEN_MFA'
                )
                .then(() => {
                    Auth.currentAuthenticatedUser({bypassCache:true})
                    .then(user => {
                        let admin = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("admin");
                        let adminLite = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("adminLite")
                        this.context[1]({type:'login',payload:user, admin: admin, adminLite: adminLite})
                        this.props.history.push('/')
                    })
                })
                .catch((error) => {
                    message.error(error.message)
                    this.context[1]({type:'endcall'})
                    this.props.history.push('/login')
                })
            }
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        if (this.props.login.fechingStatus === true){
            return null;
        }
        else if (this.props.login.calling === false && this.props.login.auth === true ) {
            return <Redirect to="/" />;
        }
        else {
            return (
                <LoginBase title="Ingreso con código MFA">
                    <Form
                        onSubmit={(e)=>this.onSubmit(e)}
                        hideRequiredMark={true}
                        style={{margin:"10px"}}
                    >
                        <Form.Item>
                        {
                            getFieldDecorator('mfa_code', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Código de verificación requerido',
                                    },
                                ]
                            })(<Input
                                    prefix={<Icon type="unlock" />}
                                    placeholder="Codigo de verificación MFA"
                                    suffix={
                                        <Tooltip title="Ingrese el código MFA">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="off"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                onClick={(e)=>this.onSubmit(e)}
                                type="primary"
                                htmlType="submit"
                                loading={this.props.login.calling}
                            >
                                Login with MFA
                            </Button>
                        </Form.Item>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const MFALogin = Form.create({ name: 'mfa-login' })(MFALoginForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MFALogin));
